var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChordFMajor = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 1",
  viewBox: "0 0 600 600",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#7cc357",
  strokeMiterlimit: 10,
  strokeWidth: 27.34,
  d: "M302.74 467.35L104.31 126.03h394.64L302.74 467.35z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#7cc357",
  strokeMiterlimit: 10,
  strokeWidth: 21.29,
  d: "M362.85 475.73a61.64 61.64 0 11-61.64-61.63 61.64 61.64 0 0161.64 61.63z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#8d6db0",
  strokeMiterlimit: 10,
  strokeWidth: 21.29,
  d: "M164.56 121.71a61.64 61.64 0 11-61.63-61.63 61.64 61.64 0 0161.63 61.63z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#7cc357",
  stroke: "#7cc357",
  strokeMiterlimit: 10,
  strokeWidth: 8,
  d: "M284.73 451.45h25.77v5.18h-19.59v15.91H309v5.11h-18.1v21.65h-6.18z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#8f6daf",
  stroke: "#8f6daf",
  strokeMiterlimit: 10,
  strokeWidth: 6.39,
  d: "M91.26 128.09l-5.07 15.34h-6.51l16.58-48.79h7.6l16.65 48.79h-6.74l-5.21-15.34zm16-4.92l-4.78-14c-1.08-3.18-1.81-6.08-2.53-8.9h-.15c-.72 2.89-1.52 5.86-2.46 8.83l-4.78 14.12z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#8dc96a",
  stroke: "#8dc96a",
  strokeMiterlimit: 10,
  strokeWidth: 3.25,
  d: "M254.65 312.19q8.59-.29 12.22-2.35 5.56-3.12 5.57-11.72v-96.84q0-8.68-5.48-11.72-3.31-1.86-12.31-2.44V182H368.1v40.36h-4.89q-3.7-18.66-12.5-26.14t-32.45-7.47q-8.79 0-11.18 2t-2.4 7.47v46.32q16.21.3 21.94-6.84t8.65-22.7h5.08v67.62h-5.08q-2.06-16.21-8.26-23.64t-22.33-7.43v46.61q0 9.28 5.42 11.77t16.57 2.3v5.08h-72z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#ef3e30",
  strokeMiterlimit: 10,
  strokeWidth: 22.43,
  d: "M558.71 118.07a61.64 61.64 0 11-61.63-61.63 61.64 61.64 0 0161.63 61.63z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#ef3e30",
  stroke: "#ef3e30",
  strokeMiterlimit: 10,
  strokeWidth: 8.01,
  d: "M510.73 140.08c-2.27 1.14-6.81 2.27-12.64 2.27-13.49 0-23.64-8.52-23.64-24.21 0-15 10.15-25.13 25-25.13 6 0 9.73 1.28 11.36 2.13l-1.49 5a22.42 22.42 0 00-9.65-2c-11.22 0-18.68 7.17-18.68 19.74 0 11.71 6.75 19.24 18.39 19.24a24.62 24.62 0 0010.08-2z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgChordFMajor);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/chord-f-major.39c6df713920c27fe29b31d3a8da07cd.svg";